// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class CloseAccountCancelRequestMessage extends PFixMessage {
    constructor() {
        super(Message.CODE_PFIX_CLOSE_ACCOUNT_CANCEL_REQUEST_MESSAGE);
    }
    setCloseAccountRequestID(reqID) {
        this.FieldSet.SetField(FieldsFactory.FIELD_CLOSE_ACCOUNT_REQUEST_ID, reqID);
    }
}
